/* template */
import AboutTemplate from "../components/template/AboutTemplate"

const About = () => {
    return (
      <AboutTemplate />
    )
}

export default About